import { Chip } from '@mui/material';

import { DrawerFormSection } from '../../../../common/components';
import {
  getPaymentOrderStatusColor,
  getPaymentOrderStatusLabel,
} from '../../utils/supplierLedgerHelpers';
import PaymentOrderPreview from '../PaymentOrderPreview';
import PaymentOrderProviderHeader from './PaymentOrderProviderHeader';

const PaymentOrderPreviewSection = ({ controller }) => {
  const {
    activeProvider,
    applications,
    form,
    includedInvoices,
    paymentForms,
    providerMap,
    providerStatuses,
  } = controller;

  return (
    <>
      <PaymentOrderProviderHeader controller={controller} />
      <DrawerFormSection
        title="Previsualización"
        action={activeProvider && (
          <Chip
            size="small"
            color={getPaymentOrderStatusColor(providerStatuses[activeProvider.providerId])}
            label={getPaymentOrderStatusLabel(providerStatuses[activeProvider.providerId])}
          />
        )}
        grid={false}
      >
        <PaymentOrderPreview
          group={activeProvider}
          applications={applications}
          form={form}
          paymentForms={paymentForms}
          status={providerStatuses[activeProvider?.providerId]}
          includedInvoices={includedInvoices}
          providerMap={providerMap}
        />
      </DrawerFormSection>
    </>
  );
};

export default PaymentOrderPreviewSection;
